import alt from 'alt'
import axios from 'axios'
import { API_BASE } from 'consts'

const SERPPreviewSource = {
  fetch: function(url) {
    return axios.get(`${API_BASE}/serp_preview?u=${encodeURIComponent(url)}`)
      .then(resp => resp.data)
  },
  fetchShopify: function(resource, limit, page) {
    return axios.get(`${API_BASE}/serp_preview_shopify`, { params: { resource, limit, page } })
      .then(resp => resp.data)
  }
}

export default SERPPreviewSource



// WEBPACK FOOTER //
// ./app/sources/SERPPreviewSource.js